import { IIntInvoiceRegister } from '@models/invoice/int-invoice-register';

export interface NewInternationalRegisterModalPayload {
  registers: IIntInvoiceRegister[],
  canEditDescription: boolean,
  canViewDescription: boolean,
  canEditDate: boolean,
  canViewDate: boolean,
  newRegisterMode: NewInternationalRegisterMode,
  getRegistersFromApi?: boolean,
  title?: string,
}

export enum NewInternationalRegisterMode {
  NEW = 'new',
  EXIST = 'exist',
}
